function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_BANKACCOUNTSBYPERSONID_REQUEST = "GET_BANKACCOUNTSBYPERSONID_REQUEST";
export var GET_BANKACCOUNTSBYPERSONID_SUCCESS = "GET_BANKACCOUNTSBYPERSONID_SUCCESS";
export var GET_BANKACCOUNTSBYPERSONID_FAILURE = "GET_BANKACCOUNTSBYPERSONID_FAILURE";
export var RESET_GET_BANKACCOUNTSBYPERSONID = "RESET_GET_BANKACCOUNTSBYPERSONID";

// Fetches an bankAccount for a particular user from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchBankAccountsByPersonId = function fetchBankAccountsByPersonId(personId) {
  return _defineProperty({
    personId: personId
  }, CALL_API, {
    types: [GET_BANKACCOUNTSBYPERSONID_REQUEST, GET_BANKACCOUNTSBYPERSONID_SUCCESS, GET_BANKACCOUNTSBYPERSONID_FAILURE],
    endpoint: "bankAccounts/search/findByPerson_Id".concat(urlSearchParams({
      projection: "full",
      personId: personId
    })),
    init: {
      credentials: "same-origin"
    }
  });
};